export default __webpack_public_path__ + "static/media/avatar-ali.88f9155c.png";